import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import CollectionStyle from '~/components/molecules/Editorial/Collection/CollectionStyle.vue';
var COLUMNS = {
  'columns 2': 'col-12 col-md-6',
  'columns 4': 'col-12 col-md-6 col-lg-3'
};
export default {
  name: 'CollectionStyles',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    CollectionStyle: CollectionStyle
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      mobile: true
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21;

      return {
        title: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.title) != null ? _ref21[0] : _ref21 : _ref21 : _ref21) || {},
        titleColor: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.title_color : _ref20 : _ref20) || '',
        subtitle: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? (_ref19 = _ref19.subtitle) != null ? _ref19[0] : _ref19 : _ref19 : _ref19) || {},
        subtitleColor: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.subtitle_color : _ref18 : _ref18) || '',
        paragraph: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.paragraph : _ref17 : _ref17) || [],
        readMore: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.read_more : _ref16 : _ref16) === 'Yes',
        background: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.background_color : _ref15 : _ref15) || '',
        columns: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.columns : _ref14 : _ref14) || '',
        ratioImages: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.ratio_images : _ref13 : _ref13) || '16:9',
        styles: this.payload.items.map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12;

          return {
            url: new UrlParse(((_ref12 = i) != null ? (_ref12 = _ref12.url) != null ? _ref12.url : _ref12 : _ref12) || '').pathname,
            image: {
              small: formatPrismicImage((_ref11 = i) != null ? (_ref11 = _ref11.image) != null ? _ref11.url : _ref11 : _ref11, ['w_375']) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref10 = i) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10, ['w_375,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref9 = i) != null ? (_ref9 = _ref9.image) != null ? _ref9.url : _ref9 : _ref9, ['w_1440']) || EMPTY_PIXEL,
              xlarge: formatPrismicImage((_ref8 = i) != null ? (_ref8 = _ref8.image) != null ? _ref8.url : _ref8 : _ref8, ['w_1440,dpr_2']) || EMPTY_PIXEL
            },
            alt: ((_ref7 = i) != null ? _ref7.alt : _ref7) || null,
            textColor: ((_ref6 = i) != null ? _ref6.text_color : _ref6) || '',
            title: ((_ref5 = i) != null ? _ref5.title : _ref5) || [],
            text: ((_ref4 = i) != null ? _ref4.text : _ref4) || '',
            tracking: {
              data: {
                event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
              }
            }
          };
        })
      };
    },
    builderCol: function builderCol() {
      return COLUMNS[this.currentPayload.columns];
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  }
};